const API_KEY = process.env.REACT_APP_API_KEY;

const API_URL = "https://sozuslugi.ru/api/v2";

export {
    API_KEY,
    API_URL
}